<nav class="admin-nav" data-testid="admin-nav">
  @for (item of viewItems; track item.path) {
    <a
      class="admin-nav__link"
      [class.admin-nav__link--active]="item.active"
      [attr.aria-current]="item.active ? 'page' : null"
      [routerLink]="item.path"
      [attr.aria-label]="item.label"
      [matTooltip]="item.label"
      data-testid="admin-nav-link"
    >
      <mat-icon aria-hidden="true">{{ item.icon }}</mat-icon>
      <span class="admin-nav__label">{{ item.label }}</span>
    </a>
  }
</nav>
